// import PageLayout from './PageLayout';
// import PageProvider from './PageProvider';

// const SurveyPage = ({ ...props }) => {
//     return (
//         <PageProvider {...props}>
//             <PageLayout />
//         </PageProvider>
//     );
// };

// export default SurveyPage;

export default () => null;
